import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "folder-navigator-component" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["onClick", "href"]
const _hoisted_5 = { key: 0 }

import { type PropType, computed } from "vue";
import FadeAndSlide from "../../../../shared/FadeAndSlide.vue";
import { type MappedProductCollectionModel } from "../../models";
import {
    findCollectionById,
    flattenAllCollectionsWithParents,
} from "../../collection-methods";
import { getCollectionUrl } from "../../collection-url";
import CheckboxItem from "../common/checkbox-item.vue";

type PreviewItemEntry = {
    col: MappedProductCollectionModel;
    depth: number;
    colScopedRoot: MappedProductCollectionModel | undefined;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  props: {
    siteGuid: Number,
    productListGuid: Number,
    value: Array as PropType<number[][]>,
    root: Array as PropType<MappedProductCollectionModel[]>,
    scopedRoot: Object as PropType<MappedProductCollectionModel>,
    baseUrl: String,
    getVisible: {
        type: Function,
        required: true,
    },
    viewMode: {
        type: Number,
        required: true,
    },
    // findCollectionById: {
    //     type: Function as PropType<
    //         (
    //             collectionId: number,
    //             mappedRoot: ProductCollectionModel[] | MappedProductCollectionModel[] | undefined
    //         ) => ProductCollectionModel
    //     >,
    //     required: true,
    // },
    //getFlattenedCollections: Function,
    matchedLogicalName: String,
    matchedLogicalNameEntityGuid: Number,
    matchedLogicalNameModuleGuid: Number,
    matchedLogicalNameSubModuleGuid: Number,
},
  emits: ["navigate-to-collection"],
  setup(__props) {



function findFirstPreviewableItems(collection: MappedProductCollectionModel) {
    const items: PreviewItemEntry[] = [];

    const limit = collection.Settings?.previewSubitems;

    if (limit == null) return items;

    const subCols = flattenAllCollectionsWithParents([collection]);

    for (const subCol of subCols) {
        if (items.length === limit) {
            // console.debug("break by limit");
            break;
        }
        if (subCol.parents.length == 0) {
            // console.debug("continue: no parents: " + subCol.collection.Name);
            continue;
        }
        const revParents = subCol.parents.concat().reverse();
        const qualifyingParentSettingIndex = revParents.findIndex(
            (x) => x.FilterViewMode == 1
        );
        if (qualifyingParentSettingIndex == -1) {
            // console.debug(
            //     "continue: no filterviewmode 1 parent found: " +
            //         subCol.collection.Name
            // );
            continue;
        }
        // console.log(subCol.parents);
        if (qualifyingParentSettingIndex < 1) {
            // console.debug(
            //     "continue: not deep enough: " + subCol.collection.Name
            // );
            continue;
        }
        if (qualifyingParentSettingIndex > 3) {
            // console.debug("continue: too deep: " + subCol.collection.Name);
            continue;
        }
        // console.debug("adding!: " + subCol.collection.Name);
        items.push({
            col: subCol.collection,
            depth: subCol.parents.length - 1,
            colScopedRoot: revParents.find((x) => x.FilterViewMode == 1),
        });
    }
    return items;
}

const props = __props;

const mappedRoot = computed(() => {
    if (props.root == null) return props.root;
    if (props.scopedRoot != null) {
        return props.scopedRoot.SubCollections;
    }
    return props.root;
});
const collectionsOwner = computed(() => {
    if (props.root == null) return props.root;
    const selectedCol = selectedCollection.value;

    let collection = null;
    if (selectedCol != null) {
        collection = selectedCol;
        if (
            !Array.isArray(collection.SubCollections) ||
            collection.SubCollections.length <= 0
        )
            collection = collection.parent;
    }

    if (collection === props.scopedRoot) collection = null;

    return collection;
});
const collections = computed(() => {
    if (props.root == null) return props.root;
    if (collectionsOwner.value == null) return mappedRoot.value;
    return collectionsOwner.value.SubCollections;
});
const selectedCollection = computed(() => {
    if (props.value == null) return props.value;
    if (props.value.length === 0) return undefined;
    if (props.value[0].length == 0) return undefined;
    const collectionId = props.value[0][0];
    return findCollectionById(collectionId, mappedRoot.value);
});

// onMounted(() => {
//     console.debug(mappedRoot.value);
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FadeAndSlide, null, {
      default: _withCtx(() => [
        (collectionsOwner.value != null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style['main-item'])
            }, [
              (collectionsOwner.value !== selectedCollection.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
                            _ctx.$emit('navigate-to-collection', collectionsOwner.value)
                        ), ["prevent"])),
                    href: 
                            _unref(getCollectionUrl)(
                                collectionsOwner.value,
                                __props.viewMode,
                                __props.baseUrl,
                                __props.value,
                                __props.root ?? [],
                                __props.matchedLogicalName,
                                __props.matchedLogicalNameEntityGuid,
                                __props.matchedLogicalNameModuleGuid,
                                __props.matchedLogicalNameSubModuleGuid
                            ) ?? '#'
                        ,
                    class: _normalizeClass(_ctx.$style['link'])
                  }, _toDisplayString(collectionsOwner.value.Name), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
                            _ctx.$emit(
                                'navigate-to-collection',
                                collectionsOwner.value.parent
                            )
                        ), ["prevent"])),
                      href: 
                            collectionsOwner.value.parent != null
                                ? _unref(getCollectionUrl)(
                                      collectionsOwner.value.parent,
                                      __props.viewMode,
                                      __props.baseUrl,
                                      __props.value,
                                      __props.root ?? [],
                                      __props.matchedLogicalName,
                                      __props.matchedLogicalNameEntityGuid,
                                      __props.matchedLogicalNameModuleGuid,
                                      __props.matchedLogicalNameSubModuleGuid
                                  ) ?? '#'
                                : '#'
                        
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.$style['back-arrow'])
                      }, null, 2 /* CLASS */)
                    ], 8 /* PROPS */, _hoisted_3),
                    _createTextVNode(" " + _toDisplayString(collectionsOwner.value.Name), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", {
      class: _normalizeClass([
                _ctx.$style['items'],
                collectionsOwner.value != null ? _ctx.$style['indented'] : '',
            ])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collections.value, (collection) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (__props.getVisible(collection))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
                            _ctx.$style['item'],
                            collection === selectedCollection.value
                                ? _ctx.$style['active']
                                : '',
                        ])
              }, [
                _createElementVNode("a", {
                  onClick: _withModifiers(($event: any) => (
                                _ctx.$emit('navigate-to-collection', collection)
                            ), ["prevent"]),
                  href: 
                                _unref(getCollectionUrl)(
                                    collection,
                                    __props.viewMode,
                                    __props.baseUrl,
                                    __props.value,
                                    __props.root ?? [],
                                    __props.matchedLogicalName,
                                    __props.matchedLogicalNameEntityGuid,
                                    __props.matchedLogicalNameModuleGuid,
                                    __props.matchedLogicalNameSubModuleGuid
                                ) ?? '#'
                            ,
                  class: _normalizeClass(_ctx.$style['link'])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.$style['forward-arrow'])
                  }, null, 2 /* CLASS */),
                  _createTextVNode(" " + _toDisplayString(collection.Name), 1 /* TEXT */)
                ], 10 /* CLASS, PROPS */, _hoisted_4),
                (collection.Settings?.previewSubitems != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(findFirstPreviewableItems(collection), ({
                                    col,
                                    depth,
                                    colScopedRoot,
                                }) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass([
                                    _ctx.$style['sub-item'],
                                    'sub-item-depth-' + depth,
                                ])
                        }, [
                          _createVNode(CheckboxItem, {
                            id: 'collectionCheckBox_' + col.Id,
                            checked: false,
                            name: col.Name,
                            href: 
                                        _unref(getCollectionUrl)(
                                            col,
                                            __props.viewMode,
                                            __props.baseUrl,
                                            __props.value,
                                            __props.root ?? [],
                                            __props.matchedLogicalName,
                                            __props.matchedLogicalNameEntityGuid,
                                            __props.matchedLogicalNameModuleGuid,
                                            __props.matchedLogicalNameSubModuleGuid
                                        ) ?? undefined
                                    ,
                            onSelect: ($event: any) => (
                                        _ctx.$emit('navigate-to-collection', {
                                            collection: col,
                                            scopedRoot: colScopedRoot,
                                        })
                                    )
                          }, null, 8 /* PROPS */, ["id", "name", "href", "onSelect"])
                        ], 2 /* CLASS */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 2 /* CLASS */)
  ]))
}
}

})